import { DefaultRouteTabs } from '@/components/_common';
import { useDisclosure } from '@/hooks';
import { Helmet } from 'react-helmet';
import { invoiceCfeRoutePage } from '../routePageConfig';
import { PageProps } from '@/types/PageProps';
import InvoiceCFePayments from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFePayments';
import { Button } from 'antd';
import InvoiceCFEPaymentCreateModal from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFePayments/InvoiceCFEPaymentCreateModal';
import { useInvoiceCFEFormContext } from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEFormProvider';
import InvoiceCFEFooter from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEFooter';
import InvoiceCFEHeader from '@/components/Fiscal/Invoice/InvoiceCFe/InvoiceCFEHeader';
import { TaxCouponStatus } from '@/core/domain/coupon/coupons/coupons.types';
import { getActiveTabPageTaxCoupon } from '@/components/Fiscal/Invoice/InvoiceCFe/getActiveTabPageTaxCoupon';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const InvoiceCFePaymentsMethodPage: React.FC<PageProps> = ({ route }) => {
  const { taxCoupon } = useInvoiceCFEFormContext();

  const disabled =
    taxCoupon?.status !== TaxCouponStatus.TYPING ||
    !hasPermissions([Authorities.FISCAL_COUPON_EDIT]);

  const [modalOpened, modalAction] = useDisclosure(false);

  return (
    <>
      <DefaultRouteTabs
        route={invoiceCfeRoutePage(route)}
        permissions={route.permissions}
        {...getActiveTabPageTaxCoupon()}
      >
        <Helmet title="Formas de pagamento" />

        <InvoiceCFEHeader
          extra={
            <Button
              type="primary"
              onClick={modalAction.open}
              disabled={disabled}
            >
              Adicionar
            </Button>
          }
        />

        <InvoiceCFePayments />

        <InvoiceCFEFooter />
      </DefaultRouteTabs>

      <InvoiceCFEPaymentCreateModal
        open={modalOpened}
        onCancel={modalAction.close}
      />
    </>
  );
};

export default InvoiceCFePaymentsMethodPage;
